import {
  ProjectStatuses,
  ProjectFeatureFlags,
  ProjectArchiveStatuses,
} from "@/components/constants.js"

export default {
  name: {
    component: "TextFieldSearchFilter",
  },
  exid: {
    component: "TextFieldSearchFilter",
  },
  cameras: {
    component: "TextFieldSearchFilter",
  },
  status: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ value: "", name: "All" }, ...ProjectStatuses],
    },
  },
  archiveTier: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ value: "", name: "All" }, ...ProjectArchiveStatuses],
    },
  },
  featureFlags: {
    component: "SelectSearchFilter",
    attributes: {
      items: ProjectFeatureFlags,
      multiple: true,
    },
  },
  startDate: {
    component: "SelectDatePickerRangeSearchFilter",
    fieldNamesMap: {
      rangeTypeField: "startDateRangeType",
      fromField: "startDateFrom",
      toField: "startDateTo",
    },
    attributes: {
      fromDateSuffix: "From",
      toDateSuffix: "To",
    },
  },
  endDate: {
    component: "SelectDatePickerRangeSearchFilter",
    fieldNamesMap: {
      rangeTypeField: "endDateRangeType",
      fromField: "endDateFrom",
      toField: "endDateTo",
    },
    attributes: {
      fromDateSuffix: "From",
      toDateSuffix: "To",
    },
  },
}
